export default __webpack_public_path__ + "static/logo-307c3250295965416b3ca3fb83f9d4a2.svg";